import React, {useState} from 'react'
import Fade from 'react-reveal/Fade';
import {useTranslation} from "react-i18next";
import {Keyboard, EndCall, Dialer, Timer, Button, ButtonCall} from 'components/UI';
import Icon from '@mdi/react';
import {mdiKeyboardVariant, mdiMicrophoneOff, mdiPhoneHangup} from '@mdi/js';

const SimpleCallForm = (props) => {
    const [isOpen, setIsOpen] = useState(false);
    const toggleKeyboard = () => {
        isOpen === true ? setIsOpen(false) : setIsOpen(true);
    }
    const {t} = useTranslation();
    let callFunc,
        callText;
    if (!props.calling) {
        callFunc = props.callSimpleHandler
        callText = t("call")
    } else {
        callFunc = props.hangUpHandler
    }

    return (
        <>
            <div style={{'display': 'flex', 'flexDirection': props.answer ? 'column' : 'row'}}>
                {!props.answer && props.calling &&
                    <Fade>
                        <Dialer/>
                        <EndCall onPhoneClick={callFunc}/>
                    </Fade>
                }
                {props.answer &&
                    <Fade>
                        <Timer start={true}/>
                        <div style={{'display': 'flex', 'flexDirection': 'row'}}>
                            <ButtonCall onClick={toggleKeyboard}>
                                <Icon path={mdiKeyboardVariant} size={1.5}/>
                            </ButtonCall>
                            <ButtonCall onClick={props.muteHandler} isActive={props.muted}>
                                <Icon path={mdiMicrophoneOff} size={1.5}/>
                            </ButtonCall>
                            <ButtonCall onClick={callFunc}>
                                <Icon path={mdiPhoneHangup} size={1.5}/>
                            </ButtonCall>
                        </div>
                    </Fade>
                }
            </div>
            <Keyboard sendDtmf={props.sendDtmfHandler} toggleKeyboard={toggleKeyboard} isOpen={isOpen}/>
            {!props.calling && <Button onButtonClick={callFunc}><b>{callText}</b></Button>}
        </>
    )
}
export default SimpleCallForm